export { default as withAnimatedResponse } from './withAnimatedResponse';
export { WithAnimatedResponseShape } from './withAnimatedResponse.types';
export {
  CODE_LINE_HEIGHT,
  LINE_HEIGHT_OFFSET,
  HOT_SPOT_OFFSET,
} from './with-animated-response-constants';
